// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__nAPcq","footer":"ModalUpdate_footer__2vvCx"};